"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _cryptoJSHelper = _interopRequireDefault(require("../cryptoJSHelper"));

var _key = require("./key");

var encryptByDES = _cryptoJSHelper["default"].encryptByDES;

var getSsid = function getSsid() {
  return '' + Date.now() + '-' + Math.floor(1e7 * Math.random()) + '-' + Math.random().toString(16).replace('.', '') + '-' + String(Math.random() * 31242).replace('.', '').slice(0, 8);
};

var desSscommon = function desSscommon(url) {
  return encryptByDES(url, (0, _key.ssCommonKey)());
};

var getSSCOMMONS = function getSSCOMMONS() {
  var ssid = getItem('ssid');

  if (!ssid) {
    ssid = getSsid();
    setItem('ssid', ssid);
  }

  var token = getItem('token');
  var advert = 'ssId=' + ssid + '&token=' + token;
  return desSscommon(advert);
};

var getItem = function getItem(item) {
  var data = window.localStorage.getItem(item);
  return data;
};

var setItem = function setItem(name, item) {
  return window.localStorage.setItem(name, "".concat(item));
};

var _default = {
  ssCommonKey: _key.ssCommonKey,
  getSSCOMMONS: getSSCOMMONS
};
exports["default"] = _default;